<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: false,
    },

    value: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <b-form-group>
    <b-form-radio-group
      id="id"
      :options="options"
      name="radio-options"
    ></b-form-radio-group>
  </b-form-group>
</template>

<style lang="scss" module>
@import '@design';
</style>
